import { apiClient } from '@/lib/api/client'

/**
 * Assume an artist's identity, for support and QA against production.
 *
 * Manager-only on the server; this client is only ever rendered for one. The token the API
 * returns IS an artist token — the same shape the artist's own session uses — so once it is in the
 * auth store every screen behaves exactly as it does for them. That is the point: a masquerade
 * that took a different code path would not show you what they actually see.
 */

export interface AssumableArtist {
  id: number
  email: string
  artisticName: string
  artworkCount: number
}

export interface MasqueradeSession {
  token: string
  expiresIn: number
  artist: { id: number; email: string; artisticName: string }
}

export const masqueradeApi = {
  /** Searchable because there are ~1300 artists; the server clamps the page size. */
  listArtists: async (q: string): Promise<AssumableArtist[]> => {
    const response = await apiClient.get<{ data: AssumableArtist[] }>('/api/masquerade/artists', {
      params: q ? { q } : undefined,
    })
    return response.data.data
  },

  begin: async (artistId: number): Promise<MasqueradeSession> => {
    const response = await apiClient.post<MasqueradeSession>('/api/masquerade', { artistId })
    return response.data
  },
}
